import { useEffect, useState } from '@wordpress/element';

export const MOBILE_BREAKPOINT = 500;

/**
 * True when viewport width is at or below the typology mobile breakpoint (matches SCSS `$mobile-breakpoint`).
 *
 * @param {number} [breakpoint=MOBILE_BREAKPOINT] max-width in px
 * @return {boolean} Whether the viewport is at or below the max-width breakpoint.
 */
export default function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
		const update = () => setIsMobile(mql.matches);

		update();
		mql.addEventListener('change', update);
		return () => mql.removeEventListener('change', update);
	}, [breakpoint]);

	return isMobile;
}
